<div class="side-nav-panel-content">
  <mat-accordion>
    <mat-expansion-panel
      (opened)="panelOpenState = true"
      (closed)="panelOpenState = false">
      <mat-expansion-panel-header>
        <mat-panel-title> Map Options </mat-panel-title>
        <mat-panel-description> </mat-panel-description>
      </mat-expansion-panel-header>

      <form
        class="settings-form"
        [formGroup]="formGroup"
        (ngSubmit)="onFormSubmit()"
        ngNativeValidate >
        <div class="slider-container">
          <mat-slide-toggle
            color="primary"
            formControlName="displayLegendChecked">
            Display Map Legend:</mat-slide-toggle>
        </div>
        <div class="slider-container">
          <mat-slide-toggle
            color="primary"
            formControlName="displayOddRampsChecked"
            >Display Odd Ramps:</mat-slide-toggle
          >
        </div>
        <div class="slider-container">
          <mat-slide-toggle
            color="primary"
            formControlName="displayEvenRampsChecked"
            >Display Even Ramps:</mat-slide-toggle
          >
        </div>
        <div class="slider-container">
          <mat-slide-toggle
            color="primary"
            formControlName="displayWingsChecked"
            >Display Wings:</mat-slide-toggle
          >
        </div>
        <div class="slider-container">
          <mat-slide-toggle color="primary" formControlName="displayPOIChecked"
            >Display Points of Interest:</mat-slide-toggle
          >
        </div>
        <div class="form-button-rows-wrap">
          <button mat-flat-button color="primary" type="submit">
            Save Settings
          </button>
        </div>
      </form>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title> Environment Info </mat-panel-title>
        <mat-panel-description> </mat-panel-description>
      </mat-expansion-panel-header>
      <div>
        <ul>
          <li>Host Api: {{ configuration.HostApi }}</li>
          <li>Environment: {{ configuration.Environment }}</li>
          <li>Coordinates Source: {{ coordinatesSource }}</li>
          <li>
            Last Coordinate Update: {{ lastCoordinateUpdate | date: "short" }}
          </li>
          <li>
            Lat/Lng: {{ coordinates?.latitude || '?' }}, {{ coordinates?.longitude || '?' }}
          </li>

        </ul>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title> Dark Mode </mat-panel-title>
        <mat-panel-description> </mat-panel-description>
      </mat-expansion-panel-header>
      <div>
        <span style="margin-right: 3px">Off</span>
        <mat-slide-toggle
          color="primary"
          [formControl]="darkModeToggle"
          class="mr-8"
        ></mat-slide-toggle>
        <span style="margin-left: 3px">On</span>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel *appHasRole="['cvv_coordinator']">
      <mat-expansion-panel-header>
        <mat-panel-title> Developer Stuff </mat-panel-title>
        <mat-panel-description> </mat-panel-description>
      </mat-expansion-panel-header>
      <div>
        <label id="settings-radio-group-label">Test Roles:</label>
        <mat-radio-group
          class="settings-radio-group"
          [(ngModel)]="impersonateRole"
        >
          <mat-radio-button
            class="settings-radio-button"
            *ngFor="let role of roles"
            [value]="role"
          >
            {{ role }}
          </mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="form-button-rows-wrap">
        <button
          mat-flat-button
          color="primary"
          [disabled]="impersonateRole === null"
          (click)="setImpersonateRole()"
          class="remove-details"
        >
          Submit
        </button>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title> Local Storage </mat-panel-title>
        <mat-panel-description> </mat-panel-description>
      </mat-expansion-panel-header>
      <div class="form-button-rows-wrap">
        <button
          mat-flat-button
          color="primary"
          (click)="clearLocalStorage()">
          Clear Local Storage
        </button>
      </div>
      </mat-expansion-panel>

  </mat-accordion>
</div>
